import {
  Form, Input, Row, Col,
} from 'antd';

export default function AccountContact() {
  return (
    <Row gutter={20}>
      <Col span={12}>
        <Form.Item label="Name" name="name">
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label="Email"
          name="email"
        // rules={[
        //   { type: 'email', message: 'Invalid email' },
        // ]}
        >
          <Input disabled />
        </Form.Item>
      </Col>
    </Row>
  );
}
